import React, { ReactElement, useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import ReactQuill from "react-quill";
import { RiPencilLine } from "@remixicon/react";
import { useEditMessageMutation } from "../../../__generated__/api";
import { useTheme } from "../../../contexts/Theme";
import Editor from "../../agent-v3/editor/Editor";
import Confirm from "../../confirm/Confirm";
import EditorLegacy, { EditorInstance } from "../../editor/Editor";
import Styles from "../Chat.module.scss";
import useChatState from "../chat-state";
import { TicketItem } from "../../../contexts/ticket-state";

export function EditMessage({
    ticketMessageId, text, ticketItem,
} : {
    text: string | undefined;
    ticketMessageId: string;
    ticketItem?: TicketItem;
}):ReactElement {
    const [body, setBody] = useState(text);

    const [editMessage] = useEditMessageMutation();
    const editorLegacyRef = React.createRef<EditorInstance>();
    const editorRef = React.createRef<ReactQuill>();

    const chatState = useChatState();
    const theme = useTheme();
    useEffect(() => {
        setBody(text);
        if (ticketMessageId) {
            setTimeout(() => {
                editorRef?.current?.focus();
                editorLegacyRef?.current?.focusEnd();
            }, 100);
        } else {
            chatState.setEditingMessageId?.(undefined);
        }
    }, [ticketMessageId]);

    const onSave = async () => {
        if (ticketItem) {
            ticketItem.editMessage(ticketMessageId, body);
        } else {
            await editMessage({
                variables: {
                    ticketMessageId,
                    message: {
                        body,
                    },
                },
            });
        }

        chatState.setEditingMessageId?.(undefined);
    };

    return (
        <Confirm
            shouldShow={ticketMessageId != null}
            onConfirm={onSave}
            size="lg"
            confirmText="Confirm"
            onHide={() => chatState.setEditingMessageId?.(undefined)}
            dialogClassName="mt-5"
            title="Edit Message"
            bodyClassName={theme.isV3 ? Styles["message-edit-body"] : ""}
        >

            {theme.isV3 ? (
                <Editor
                    ref={editorRef}
                    onChange={change => setBody(change)}
                    value={body || ""}
                    // className={`border ${Styles.editor}`}
                />

            ) : (
                <EditorLegacy
                    ref={editorLegacyRef}
                    onChange={change => setBody(change)}
                    text={body}
                    className={`border ${Styles.editor}`}
                    shouldAllowAttachments={false}
                />

            )}

        </Confirm>
    );
}

EditMessage.defaultProps = {
    ticketItem: undefined,
};

export default function EditMessageAction({ ticketMessageId, iconOnly }: {
    ticketMessageId: string;
    iconOnly?: boolean;
}): ReactElement {
    const state = useChatState();
    const theme = useTheme();
    return (
        <Dropdown.Item
            onClick={() => state.setEditingMessageId?.(ticketMessageId)}
            className={theme.isV3 ? "" : "text-white"}
            title={iconOnly ? "Edit Message" : undefined}
        >
            {iconOnly ? <RiPencilLine /> : "Edit Message"}
        </Dropdown.Item>
    );
}

EditMessageAction.defaultProps = {
    iconOnly: false,
};
